import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import ThemeToggleIcon from '../ThemeToggle/ThemeToggleIcon';
import { HiMenu } from "react-icons/hi";
import { IoClose } from "react-icons/io5";

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <nav className="fixed top-0 left-0 w-full z-50 bg-white/90 dark:bg-dark-bg/90 backdrop-blur-md shadow-md transition-colors duration-300">
      <div className="max-w-6xl mx-auto px-4 py-4 flex justify-between items-center">
        {/* Logo */}
        <Link to="/" className="text-xl font-bold text-gray-800 dark:text-gray-100">
          Chaitanya Bharat
        </Link>

        {/* Desktop Navigation */}
        <div className="hidden md:flex gap-6 items-center">
          <Link to="/about" className="text-gray-800 dark:text-gray-200 hover:text-blue-500">About</Link>
          <Link to="/skills" className="text-gray-800 dark:text-gray-200 hover:text-blue-500">Skills</Link>
          <Link to="/projects" className="text-gray-800 dark:text-gray-200 hover:text-blue-500">Projects</Link>
          <Link to="/contact" className="text-gray-800 dark:text-gray-200 hover:text-blue-500">Contact</Link>
          <ThemeToggleIcon />
        </div>

        {/* Mobile Hamburger */}
        <div onClick={toggleMenu} className="md:hidden cursor-pointer text-gray-800 dark:text-white z-50">
          {isMenuOpen ? <IoClose size={28} /> : <HiMenu size={28} />}
        </div>
      </div>

      {/* Mobile Navigation Menu */}
      {isMenuOpen && (
        <div className="md:hidden fixed top-0 left-0 w-full h-screen bg-white dark:bg-dark-bg flex flex-col items-center justify-center gap-6 text-gray-800 dark:text-white text-lg z-40">
          <Link to="/about" onClick={toggleMenu} className="hover:text-blue-500">About</Link>
          <Link to="/skills" onClick={toggleMenu} className="hover:text-blue-500">Skills</Link>
          <Link to="/projects" onClick={toggleMenu} className="hover:text-blue-500">Projects</Link>
          <Link to="/contact" onClick={toggleMenu} className="hover:text-blue-500">Contact</Link>
          <div className="absolute top-4 right-4">
            <ThemeToggleIcon />
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
